var __webpack_error__ = new Error();
module.exports = new Promise(function(resolve, reject) {
	if(typeof billing !== "undefined") return resolve();
	__webpack_require__.l("https://v2-billing.apps.qorcommerce.io/remoteEntry.js", function(event) {
		if(typeof billing !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "billing");
}).then(function() { return billing; });